module.exports = __webpack_public_path__ + "img/statistic.25d31837.svg";